import { IRI } from '@/api';

export default {
  payload: (state) => {
    const payload = Object.assign({}, state.item);

    const safeIri = (iri, id) => {
      id = id.toString().replace(iri, '');
      return `${iri}${id}`;
    };

    if (payload.cover && payload.cover.id) {
      payload.cover = safeIri(IRI.storage, payload.cover.id);
    }

    if (payload.company && payload.company.id) {
      payload.company = safeIri(IRI.company, payload.company.id);
    }

    if (payload.exam && payload.exam.id) {
      payload.exam = payload.exam.id;
    }

    if (!payload.lectures) {
      return payload;
    }

    payload.lectures.map((lecture, index) => {
      if (payload.lectures[index].id) {
        payload.lectures[index].id = safeIri(IRI.lecture, lecture.id);
      }

      if (payload.lectures[index].video && payload.lectures[index].video.id) {
        const video = payload.lectures[index].video;
        payload.lectures[index].video.id = safeIri(IRI.video, lecture.video.id);

        if (video.video && video.video.id) {
          payload.lectures[index].video.video.id = safeIri(IRI.storage, video.video.id);
          payload.lectures[index].video.video['@id'] = payload.lectures[index].video.video.id;
        }

        if (video.mobile && video.mobile.id) {
          payload.lectures[index].video.mobile.id = safeIri(IRI.storage, video.mobile.id);
          payload.lectures[index].video.mobile['@id'] = payload.lectures[index].video.mobile.id;
        }
      }

      if (!lecture.material || !lecture.material.files) {
        return;
      }

      if (payload.lectures[index].material.id) {
        payload.lectures[index].material.id = lecture.material.id;
      }

      payload.lectures[index].material.files = lecture.material.files.map(file => file.id);
    });

    return payload;
  },
};
